import { generateGuestCheckCustomizingReceiptsObj, generateGuestCheckCourseOrderArray } from './chunk-IJCQWVKM.mjs';
import { getDiffArray } from './chunk-RPUBZJ2D.mjs';
import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/settingsDifferences/diffGuestReceiptFactory.ts
var BasicFieldLabels = /* @__PURE__ */ ((BasicFieldLabels2) => {
  BasicFieldLabels2[BasicFieldLabels2["showLogo"] = 0] = "showLogo";
  BasicFieldLabels2[BasicFieldLabels2["showCheckTotals"] = 1] = "showCheckTotals";
  BasicFieldLabels2[BasicFieldLabels2["printMerchantCopy"] = 2] = "printMerchantCopy";
  BasicFieldLabels2[BasicFieldLabels2["fontSize"] = 3] = "fontSize";
  BasicFieldLabels2[BasicFieldLabels2["fontWeight"] = 4] = "fontWeight";
  BasicFieldLabels2[BasicFieldLabels2["spaceBetweenItems"] = 5] = "spaceBetweenItems";
  BasicFieldLabels2[BasicFieldLabels2["showSuggestedTips"] = 6] = "showSuggestedTips";
  BasicFieldLabels2[BasicFieldLabels2["showTipTotalLines"] = 7] = "showTipTotalLines";
  BasicFieldLabels2[BasicFieldLabels2["tipOption1"] = 8] = "tipOption1";
  BasicFieldLabels2[BasicFieldLabels2["tipOption2"] = 9] = "tipOption2";
  BasicFieldLabels2[BasicFieldLabels2["tipOption3"] = 10] = "tipOption3";
  BasicFieldLabels2[BasicFieldLabels2["showFooterDescription"] = 11] = "showFooterDescription";
  BasicFieldLabels2[BasicFieldLabels2["footerDescription"] = 12] = "footerDescription";
  BasicFieldLabels2[BasicFieldLabels2["showTaxesIndividually"] = 13] = "showTaxesIndividually";
  BasicFieldLabels2[BasicFieldLabels2["printOrderQr"] = 14] = "printOrderQr";
  return BasicFieldLabels2;
})(BasicFieldLabels || {});
var ItemsFieldLabels = /* @__PURE__ */ ((ItemsFieldLabels2) => {
  ItemsFieldLabels2[ItemsFieldLabels2["showItems"] = 0] = "showItems";
  ItemsFieldLabels2[ItemsFieldLabels2["showItemUnitPrice"] = 1] = "showItemUnitPrice";
  ItemsFieldLabels2[ItemsFieldLabels2["displayDefaultModifiers"] = 2] = "displayDefaultModifiers";
  ItemsFieldLabels2[ItemsFieldLabels2["groupSameModItems"] = 3] = "groupSameModItems";
  ItemsFieldLabels2[ItemsFieldLabels2["noForDeselectedDefaultModifiers"] = 4] = "noForDeselectedDefaultModifiers";
  ItemsFieldLabels2[ItemsFieldLabels2["hideModGroupTitles"] = 5] = "hideModGroupTitles";
  ItemsFieldLabels2[ItemsFieldLabels2["addSubForMultiSelectOff"] = 6] = "addSubForMultiSelectOff";
  ItemsFieldLabels2[ItemsFieldLabels2["printZeroForFreeModItems"] = 7] = "printZeroForFreeModItems";
  ItemsFieldLabels2[ItemsFieldLabels2["onlyPrintModItemsWithPrice"] = 8] = "onlyPrintModItemsWithPrice";
  ItemsFieldLabels2[ItemsFieldLabels2["modifierItemDisplayMode"] = 9] = "modifierItemDisplayMode";
  return ItemsFieldLabels2;
})(ItemsFieldLabels || {});
var AdvancedOptionsFieldLabels = /* @__PURE__ */ ((AdvancedOptionsFieldLabels2) => {
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["showTaxIndicator"] = 0] = "showTaxIndicator";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["taxIndicatorPosition"] = 1] = "taxIndicatorPosition";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["taxIndicatorColor"] = 2] = "taxIndicatorColor";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["taxIndicator"] = 3] = "taxIndicator";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["taxExemptIndicator"] = 4] = "taxExemptIndicator";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["customTypeNameDineIn"] = 5] = "customTypeNameDineIn";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["customTypeNameCurbside"] = 6] = "customTypeNameCurbside";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["customTypeNameToGo"] = 7] = "customTypeNameToGo";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["customTypeNameDelivery"] = 8] = "customTypeNameDelivery";
  AdvancedOptionsFieldLabels2[AdvancedOptionsFieldLabels2["customTypeNamePickup"] = 9] = "customTypeNamePickup";
  return AdvancedOptionsFieldLabels2;
})(AdvancedOptionsFieldLabels || {});
var ItemSortPriorityLabels = /* @__PURE__ */ ((ItemSortPriorityLabels2) => {
  ItemSortPriorityLabels2[ItemSortPriorityLabels2["sortItemsBy"] = 0] = "sortItemsBy";
  ItemSortPriorityLabels2[ItemSortPriorityLabels2["secondSortItemsBy"] = 1] = "secondSortItemsBy";
  return ItemSortPriorityLabels2;
})(ItemSortPriorityLabels || {});
var returnLabel = (field) => {
  if (field in BasicFieldLabels) {
    return i18n_config_default.t(
      `app.modals.guestReceiptDiffModal.basic.${field}`
    );
  }
  if (field in ItemsFieldLabels) {
    return i18n_config_default.t(
      `app.modals.guestReceiptDiffModal.items.${field}`
    );
  }
  if (field in AdvancedOptionsFieldLabels || field in ItemSortPriorityLabels) {
    return i18n_config_default.t(
      `app.modals.kitchenTicketDiffModal.ticketDisplay.${field}`
    );
  }
};
var diffGuestReceiptFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    const mapFn = (diff) => {
      const { field, value } = diff;
      if (field === "modifierItemDisplayMode") {
        return __spreadProps(__spreadValues({}, diff), {
          textValue: i18n_config_default.t(
            `settingsModule.registerTicketSettings.ticketDisplay.modifiersDisplay.modifierItemDisplayMode.options.${value}`
          )
        });
      } else if (field === "fontSize") {
        return __spreadProps(__spreadValues({}, diff), {
          textValue: i18n_config_default.t(
            `settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontSize.options.${value}`
          )
        });
      } else if (field === "taxIndicatorPosition") {
        return __spreadProps(__spreadValues({}, diff), {
          textValue: i18n_config_default.t(
            `commonTexts.${diff.value.toString().toLowerCase()}`
          )
        });
      } else if (field === "taxIndicatorColor") {
        return __spreadProps(__spreadValues({}, diff), {
          textValue: i18n_config_default.t(
            `settingsModule.kitchenTicketSettings.printerColors.${diff.value}`
          )
        });
      } else if (field === "spaceBetweenItems") {
        return __spreadProps(__spreadValues({}, diff), {
          textValue: `${diff.value}"`
        });
      } else if (field === "fontWeight") {
        return __spreadProps(__spreadValues({}, diff), {
          textValue: i18n_config_default.t(
            `settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontWeight.options.${diff.value}`
          )
        });
      } else if (field === "tipOption1" || field === "tipOption2" || field === "tipOption3") {
        return __spreadProps(__spreadValues({}, diff), {
          textValue: `${diff.value}%`
        });
      } else if (field === "sortItemsBy") {
        return __spreadProps(__spreadValues({}, diff), {
          textValue: i18n_config_default.t(
            `settingsModule.guestCheckSettings.sortItemsBy.options.${value}`
          )
        });
      } else if (field === "secondSortItemsBy") {
        return __spreadProps(__spreadValues({}, diff), {
          textValue: i18n_config_default.t(
            `settingsModule.guestCheckSettings.secondSortItemsBy.options.${value}`
          )
        });
      }
      return diff;
    };
    const basicChanges = getDiffArray(
      diffArray,
      returnLabel,
      BasicFieldLabels,
      1
    ).map(mapFn);
    const itemChanges = getDiffArray(
      diffArray,
      returnLabel,
      ItemsFieldLabels,
      1
    ).map(mapFn);
    const advancedChanges = getDiffArray(
      diffArray,
      returnLabel,
      [AdvancedOptionsFieldLabels, ItemSortPriorityLabels],
      [1, 1]
    ).map(mapFn);
    const customizingReceipts = generateGuestCheckCustomizingReceiptsObj(diffArray);
    const courseChanges = generateGuestCheckCourseOrderArray(diffArray, state);
    return {
      basicChanges,
      itemChanges,
      advancedChanges,
      customizingReceipts,
      courseChanges
    };
  }
  return null;
};

export { diffGuestReceiptFactory };
